mutation CreateStreamEntrypoint($input: CreateStreamEntrypointInput!) {
  createStreamEntrypoint(input: $input) {
    id
  }
}
